<template>
    <form-component ref="form" class="settings-page container">
        <div class="row">
            <div class="col">
                <div class="box">
                    <h4>Instellingen wijzigen</h4>
                    <datetime v-model="walk.walkSettings.endTime"
                              type="datetime"
                              input-id="startDate"
                              zone="local"
                              value-zone="local"
                              input-style="width: 100%;
                                  border: 1px solid #d8dbe1;
                                  border-radius: 3px;
                                  height: 52px;
                                  padding: 1rem;">
                        <label for="startDate" slot="before">Eindtijd</label>
                    </datetime>
                </div>
            </div>
        </div>

        <div class="map-container">
            <div class="row">
                <div class="col">
                    <div class="box">
                        <h4>Wijzig het gebied</h4>
                      <input-component
                          type="number"
                          label="Marge in aantal meters"
                          v-model="marginInMeters">
                      </input-component>
                        <gmap-map :center="center"
                                  :zoom="12"
                                  style="width: 100%; height: 650px;"
                                  id="map"
                                  ref="map">
                            <gmap-marker
                                    v-for="(marker, index) in locationsOfInterst"
                                    :key="index"
                                    :position="marker.position"
                                    :label="marker.title"
                                    :draggable="false"
                                    @click="onMarkerClicked(marker, index)">
                            </gmap-marker>
                            <gmap-polygon :path="areaWithMargin" @click="onPolygonClicked($event)">
                            </gmap-polygon>
                        </gmap-map>
                    </div>
                </div>
            </div>
        </div>

        <button-component
                :loading="this.submitted"
                @click.native="onSaveClick">
            Instellingen opslaan
        </button-component>

        <button-component
                :loading="this.submitted"
                @click.native="onFinishClick">
            Smartwatch innemen
        </button-component>

        <MapMarkerDetails
                v-show="showMapMarkerDetails"
                v-bind:header="modalHeaderText"
                v-bind:body="modalBodyText"
                v-bind:markerLatLngData="markerLatLngData"
                v-bind:buttonLeft="modalButtonLeft"
                v-bind:buttonRight="modalButtonRight"
                @onCloseModalClicked="onCloseModalClicked"
                @onSaveMarkerClicked="onSaveMarkerClicked">
        </MapMarkerDetails>
    </form-component>
</template>

<script>
import FormComponent from '../components/fields/form.component.vue';
    import ButtonComponent from '../components/button.component.vue';
    import InputComponent from '../components/fields/input.component.vue';
    import MapMarkerDetails from '../components/map.marker.details.vue';
    import { RouteName } from '@/utils/enums';
    import { Walk } from "@/domain/walk";
    import { Datetime } from 'vue-datetime';
    import LocationService from  '../services/location.service';

    const locationService = new LocationService();

    export default {
        name: 'active-smartwatch-settings-page',
        components: {
            FormComponent,
            ButtonComponent,
            InputComponent,
            Datetime,
            MapMarkerDetails
        },
        mounted() {
            this.$refs.map.$mapPromise.then((map) => {
                map.addListener('click', (event) => {
                    this.markerLatLngData = event.latLng;
                    this.showMapMarkerDetails = true;
                });
            });
        },
        data() {
            return {
                mapLoaded: false,
                center: { lat: 1, lng: 1 },
                walk: Walk,
                editArea: false,
                submitted: false,
                areaWithMargin: [],
                locationsOfInterst: [],
                showMapMarkerDetails: false,
                // Modal data
                modalHeaderText: 'Nieuwe locatie toevoegen' ,
                modalBodyText: 'Voer de naam van de locatie waar de cliënt naartoe wilt in:',
                modalButtonLeft: 'Annuleren',
                modalButtonRight: 'Opslaan',
                markerLatLngData: undefined,
                marginInMeters: 1 // default
            };
        },
        created() {
            this.walk = this.$store.getters.getActiveWalk;
            this.marginInMeters = this.walk.walkSettings.marginInMeters;
            // set homeLocationGeoPoint to center the map
            const homeLocationGeoPoint = this.walk.walkSettings.homeLocationGeoPoint;
            this.center = { lat: homeLocationGeoPoint.lat, lng: homeLocationGeoPoint.lng };
            // map the geoLocations from the walkSettings to show the area on the map
            this.mapGeoLocations();

            // map the locationsOfInterest from the walkSettings to show the selected locations on the map
            // need a small timeout for google to load after the component is mounted
            const drawMarkers = () => setTimeout (() => {
                this.mapLocationsOfInterest();
            }, 250);

            drawMarkers();
        },
      watch: {
        // recalculate the geofence when the marginInMeters is changed
        marginInMeters: function () {
          // // total area, with the calculated margin included
          const locationsWithMargin = locationService.addMarginPointsAroundMarker(this.locationsOfInterst, this.marginInMeters);
          // // the total area (geoFence) with marging around the locations
          this.areaWithMargin = locationService.calculateGeoFence(locationsWithMargin);
        }
      },
        methods: {
            mapGeoLocations: function() {
                this.walk.walkSettings.geoPoints.forEach(geoPoint => {
                    this.areaWithMargin.push({ lat: geoPoint.lat, lng: geoPoint.lng });
                });
            },

            mapLocationsOfInterest: function() {
                this.walk.walkSettings.locationsOfInterest.forEach(location => {
                    const point = new google.maps.LatLng(location.lat, location.lng);
                    this.locationsOfInterst.push({ title: location.title, position: point});
                });
            },

            onMarkerClicked: function(marker, index) {
                if (marker.title === 'Woonlocatie') {
                    return;
                }
                this.locationsOfInterst.splice(index, 1); // remove marker from the map
                // total area, with the calculated margin included
                const locationsWithMargin = locationService.addMarginPointsAroundMarker(this.locationsOfInterst, this.marginInMeters);
                // the total area (geoFence) with marging around the locations
                this.areaWithMargin = locationService.calculateGeoFence(locationsWithMargin);
            },
            onPolygonClicked: function(event) {
                this.markerLatLngData = event.latLng;
                this.showMapMarkerDetails = true;
            },
            addMarker: function(location, locationName) {
                // selected locations
                this.locationsOfInterst = [...locationService.addMarker(location, this.locationsOfInterst, locationName)];
                // total area, with the calculated margin included
                const locationsWithMargin = locationService.addMarginPointsAroundMarker(this.locationsOfInterst, this.marginInMeters);
                // the total area (geoFence) with marging around the locations
                this.areaWithMargin = locationService.calculateGeoFence(locationsWithMargin);
            },

            onSaveMarkerClicked: function(markerData, locationName) {
                this.addMarker(markerData, locationName);
                this.showMapMarkerDetails = false;
            },

            onCloseModalClicked: function() {
                this.showMapMarkerDetails = false;
            },

            onSaveClick: function() {
                this.submitted = true;
                // map the locationsOfInterst from google.map.LatLng's to a geoPoint object
                this.walk.walkSettings.locationsOfInterest = this.locationsOfInterst.map(location => {
                    return {
                        title: location.title,
                        lat: location.position.lat(),
                        lng: location.position.lng()
                    };
                });
                this.walk.walkSettings.marginInMeters = this.marginInMeters;
                this.walk.walkSettings.geoPoints = this.areaWithMargin;
                this.$store.dispatch('UPDATE_WALK', this.walk)
                    .then(response => {
                        if (response.status === 200) {
                            this.$router.push({ name: RouteName.SMARTWATCH_OVERVIEW });
                        }
                    });
            },

            onFinishClick: function () {
                this.$store.dispatch('SET_WALK_TO_FINISH', this.walk);
                this.$router.push({ name: RouteName.UNCONNECT_NOTE });
            }
        }
    };
</script>
<style scoped lang="scss">
    @import "../../node_modules/vue-datetime/dist/vue-datetime.css";

    .row {
        flex-direction: column;

        @include desktop {
            flex-direction: row;
        }
    }

    .box {
        margin-bottom: 2rem;

        @include desktop {
            background-color: $white;
            // height: 100%;
            padding: 1rem;
            box-shadow: 0 -2px 8px 0px rgba(0, 0, 0, 0.1);
            border-radius: 0.25rem;
        }

        h4 {
            font-weight: 400;
            margin-bottom: 1rem;
            color: $gray-darkest;
        }

        p {
            color: $gray-dark;
        }
    }
</style>
